module.exports = __webpack_public_path__ + "static/ml_icon-301601cae2d6921751465ee0ad8f9e5b.svg";